document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-collection')) return;

  const sidebar = document.querySelector('.productgrid--sidebar');
  if (!sidebar) return;

  const groups = Array.from(
    sidebar.querySelectorAll('[data-productgrid-sidebar-group]')
  );

  const lengthGroup = groups.find(group =>
    group.querySelector('.productgrid--sidebar-title--small')?.textContent.trim() === 'Length'
  );

  const widthGroup = groups.find(group =>
    group.querySelector('.productgrid--sidebar-title--small')?.textContent.trim() === 'Width'
  );

  if (lengthGroup && widthGroup) {
    lengthGroup.after(widthGroup);
  }
});
